
import { defineComponent } from "vue";
import KTMenu from "@/layout/header/Menu.vue";
import KTTopbar from "@/layout/header/Topbar.vue";
// import TopSearchField from "@/common/components/TopSearchField.vue";
import TopMenuList from "@/layout/header/topMenuList.vue";
import {
  headerWidthFluid,
  headerLeft,
  asideDisplay,
} from "@/core/helpers/config";

export default defineComponent({
  name: "KTHeader",
  props: {
    title: String,
  },
  components: {
    KTMenu,
    KTTopbar,
    // TopSearchField,
    TopMenuList,
  },
  setup() {
    return {
      headerWidthFluid,
      headerLeft,
      asideDisplay,
    };
  },
});
